import { getSelectedUserGroupIdCookie } from '@/features/business/utils/selectedUserGroupCookie'
import { isOnServer } from '@shared/constants/util'
import { queryOptions } from '@tanstack/react-query'

export const selectedUserGroupQueryOptions = queryOptions({
  queryKey: ['selectedUserGroup'],
  queryFn: (): string | null => {
    if (isOnServer()) {
      throw new Error('selectedUserGroupQueryOptions queryFn should not be called on the server')
    }
    return getSelectedUserGroupIdCookie() ?? null
  },
  gcTime: Infinity,
  staleTime: Infinity,
})
